// Clients are grouped into two claims. The API keeps its historical case tab
// values: BHP is the English claim (BHP-Individuals, BHP-Indigenous and
// Mariana 2026) and ARD is the Dutch claim (Project Unicorn / Unicorn II).
export const CLAIM_TABS = Object.freeze({
  ALL: "ALL",
  ENGLISH: "BHP",
  DUTCH: "ARD",
});

export const LEGACY_MARIANA_CASE_TAB = "MARIANA_2026";

export const CLAIM_LABEL_KEYS = Object.freeze({
  [CLAIM_TABS.ENGLISH]: "clientsTable.englishClaim",
  [CLAIM_TABS.DUTCH]: "clientsTable.dutchClaim",
});

export const getClaimProgram = (caseType = "") => {
  const normalizedCaseType = (caseType || "").toLowerCase();

  if (normalizedCaseType.includes("bhp")) return CLAIM_TABS.ENGLISH;
  if (normalizedCaseType.includes("mariana 2026")) return CLAIM_TABS.ENGLISH;
  if (normalizedCaseType.includes("unicorn")) return CLAIM_TABS.DUTCH;

  return "OTHER";
};

export const getClaimShortLabel = (caseType, t) => {
  const labelKey = CLAIM_LABEL_KEYS[getClaimProgram(caseType)];
  if (labelKey) return t ? t(labelKey) : labelKey;
  return caseType || "-";
};

// A tab saved before the Mariana 2026 tab was folded into the English claim.
export const normalizeClaimTab = (caseTab) =>
  caseTab === LEGACY_MARIANA_CASE_TAB ? CLAIM_TABS.ENGLISH : caseTab;

// Until the backend folds Mariana 2026 into BHP (signalled by
// `bhpIncludesMariana`), the English claim count is BHP plus Mariana 2026.
export const getEnglishClaimCount = (
  source = {},
  bhpKey = "bhp",
  marianaKey = "mariana2026",
) => {
  const bhp = Number(source?.[bhpKey]) || 0;
  if (source?.bhpIncludesMariana) return bhp;
  return bhp + (Number(source?.[marianaKey]) || 0);
};

export const getEnglishClaimClients = (summary = {}) =>
  getEnglishClaimCount(summary, "bhpClients", "marianaClients");
